import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
}));

    export default useStyles;